import { QueryKey, QueryClient } from '@tanstack/react-query';

export const removeItemFromQueriesCache = <T extends { id: string }[]>(
  queryClient: QueryClient,
  queryKey: QueryKey,
  id: string,
) => {
  const queryData = queryClient.getQueriesData<T>({ queryKey });
  queryData.forEach(([key, data]) => {
    if (data && !Array.isArray(data)) throw new Error('Data must be an array');

    const newData = data ? data.filter((d) => d.id !== id) : data;
    queryClient.setQueryData(key, newData);
  });
};

export const addItemToQueriesCache = <T>(queryClient: QueryClient, queryKey: QueryKey, item: T) => {
  const queryData = queryClient.getQueriesData<T[]>({ queryKey });
  queryData.forEach(([key, data]) => {
    if (data && !Array.isArray(data)) throw new Error('Data must be an array');

    const newData = data ? [...data, item] : [item];
    queryClient.setQueryData(key, newData);
  });
};
